import { BehaviorAttachment } from './behavior-attachment.model';
import { BehaviorStudent } from './behavior-student.model';

export class BehaviorIncident {
    Id: number;
    EventId: number;
    StudentId: number;
    IncidentCode = '';
    DCID: number;
    Comments = '';
    AddedBy: number;
    AddedOn: Date;
    LastUpBy: number;
    LastUpOn: Date;
    GangRelated = false;
    AlcoholRelated = false;
    DrugRelated = false;
    HateCrimeRelated = false;
    WeaponRelated = false;
    ReportedToPolice = false;
    WeaponDescription = '';
    DelStatus = false;
    DelBy: number;
    InvolvementType = '';
    Firearms = '';
    NonFireArms = '';
    IsNonStudent = false;
    IsUnknownStudent = false;
    MemId: number;
    IsReportedToState = false;
    CampusOfResponsibility: number;
    ConsecutiveDays: number;
    PublishCommentsToParent = false;
    IncidentNumber = '';
    Attachments: BehaviorAttachment[] = [];
    SeriousBodilyInjury = false;
    InfractionCost = '';
    // v9
    ActionCode: string;
    IncidentsFunctionalCodeId: number;
    FunctionalMotivational: string;
    SchoolId: number;
    AYIdentifier: string;
    IncidentTime: string;
    Date: Date = null;
    Location = '';
    ReportedBy: number;
    Students: BehaviorStudent[] = [];
    ZeroTolerancePolicy: boolean;
    EducationalServices: boolean;
    WeaponCode: number;
    InterimAlternativeSetting: string;
    DisciplineModifier: string;
    ConversionDays: string;
    PrimaryWeaponCode: number;
    SecondaryWeaponCode: number;
    TertiaryWeaponCode: number;
    ViolentCriminalArrest = false;
    PerpetratorInjury: string;
    SchoolPolicyDescription: string;
    Seclusion: boolean;
    Restraint: boolean;
    AcademicServices: string;
    BehaviorServices: string;
    ReengagementMeeting: Date = null;
    SubmissionPetitionForReadmission: Date = null;
    GrantedPetitionForReadmission: Date = null;
    PetitionforExtension: string;
    AppealCode: string;
    ReengagementPlan: string;
    StudentNickName: string;
    NonStudentId: number;
    AddedByStaff: string;
    IncidentRefferalId: number;
    DisciplineIncidentSubCodesId: number;
    EnteredBy: number;
    LocationId = '';
}